import { getMerchantApiProp } from 'modules/user/selectors/merchant';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import actions from '../actions';
import { Merchant } from '../types';

type UseUser = {
  user: any;
  // Merchant
  merchant: Merchant;
  currency: any;
  hasMerchandisingRulesFeatureEnabled: boolean;
  signIn: () => any;
  register: () => any;
  signOut: () => any;
  setMerchantId: () => any;
  setOnboardingId: () => any;
  setPassword: () => any;
  resetPassword: () => any;
  forgotPassword: () => any;
  getUser: () => any;
  getMerchant: () => any;
  validateCC: () => any;
  getShopifyThemes: () => any;
  integrateShopify: () => any;
  checkShopifyOnlineStore2Support: () => any;
  updateMerchantPlatform: () => any;
};

const useUser = (): UseUser => {
  const dispatch = useDispatch();

  const state = useSelector(
    createStructuredSelector({
      user: (state) => state.user.data,
      merchant: (state) => state.user?.merchant,
      hasMerchandisingRulesFeatureEnabled: (state) =>
        state.user?.merchant?.plan !== 'small',
      currency: getMerchantApiProp('currency'),
    }),
    shallowEqual
  );

  return {
    ...state,
    signIn: () => dispatch(actions.signIn()),
    register: () => dispatch(actions.register()),
    signOut: () => dispatch(actions.signOut()),
    setMerchantId: () => dispatch(actions.setMerchantId()),
    setOnboardingId: () => dispatch(actions.setOnboardingId()),
    setPassword: () => dispatch(actions.setPassword()),
    resetPassword: () => dispatch(actions.resetPassword()),
    forgotPassword: () => dispatch(actions.forgotPassword()),
    getUser: () => dispatch(actions.getUser()),
    getMerchant: () => dispatch(actions.getMerchant()),
    validateCC: () => dispatch(actions.validateCC()),
    getShopifyThemes: () => dispatch(actions.getShopifyThemes()),
    integrateShopify: () => dispatch(actions.integrateShopify()),
    checkShopifyOnlineStore2Support: () =>
      dispatch(actions.checkShopifyOnlineStore2Support()),
    updateMerchantPlatform: () => dispatch(actions.updateMerchantPlatform()),
  };
};

export default useUser;
